import { css } from '@emotion/react';
import { graphql } from 'gatsby';
import React from 'react';
import AccordionSet from '../accordion-set';
import Container from '../../../primitives/grid/container';
import { colors } from '../../../primitives/colors';
import { StyledButtonAsLink } from '../../../primitives/styled-button';
import paddingDefault from '../../../utils/padding-default';
import { breakpoints } from '../../../primitives/tokens';
import { FaqsData } from '../types/faqs-types';

const styles = {
    backgroundLight: css({
        backgroundColor: 'transparent',
    }),
    backgroundDark: css({
        backgroundColor: colors.shadesBlack,
    }),
    buttonWrap: css({
        display: 'flex',
        marginTop: '48px',
        [breakpoints.mb]: {
            marginTop: '40px',
        },
    }),
    accordionWrap: css({
        paddingRight: '64px',
        paddingLeft: '80px',
        marginBottom: '8px',
        [breakpoints.mb]: {
            paddingRight: '0',
            paddingLeft: '0',
        },
    }),
};

const Faqs = ({ settings, link, headline, byline, questions }: FaqsData): JSX.Element => {
    const { darkMode } = settings;
    const transformedData = {
        settings,
        heading: headline,
        byline,
        questions,
    };

    return (
        <div css={[paddingDefault(), darkMode ? styles.backgroundDark : styles.backgroundLight]}>
            <Container>
                <div css={styles.accordionWrap}>
                    <AccordionSet
                        faqs={transformedData}
                        onDark={darkMode}
                    />
                    {link?.href && (
                        <div css={styles.buttonWrap}>
                            <StyledButtonAsLink to={link.href}>{link.title}</StyledButtonAsLink>
                        </div>
                    )}
                </div>
            </Container>
        </div>
    );
};

export const query = graphql`
  fragment FaqsData on CsFaqs {
    ... on CsFaqs {
      settings {
        darkMode
      }
      link {
        href
        title
      }
      headline
      byline
      questions {
        questions {
          question
          answer
        }
      }
    }
  }
`;

export default Faqs;
